function customizeNavbarSection(navbarSection) {
  // Check if the current page is the homepage
  // if (window.location.pathname === '/') {
  //   addErgoLineAnimations(navbarSection);
  // } else {
  //   setNavbarBackgroundOpacity(navbarSection.find('.mad-navbar__bg'), 1);
  // }
}

function addErgoLineAnimations(navbarSection) {
  gsap.registerPlugin(ScrollTrigger);
  var navbarBackground = navbarSection.find('.mad-navbar__bg');
  
  function initBackgroundOpacity() {
    if (jQuery(window).scrollTop() === 0) {
      if (!jQuery(navbarBackground).parent().is(':hover')) {
        setNavbarBackgroundOpacity(navbarBackground, 0);
      }
    } else {
      setNavbarBackgroundOpacity(navbarBackground, 1);
    }
  }

  initBackgroundOpacity();

  // ScrollTrigger animation
  ScrollTrigger.create({
    trigger: navbarBackground,
    start: "top+=20 top",
    end: "top+=20 top",
    onEnter: () => {
      console.log("Entering scroll trigger area");
      setNavbarBackgroundOpacity(navbarBackground, 1);
    },
    onLeaveBack: () => {
      console.log("Leaving scroll trigger area");
      if (!jQuery(navbarBackground).parent().is(':hover')) {
        setNavbarBackgroundOpacity(navbarBackground, 0);
      }
    },
    markers: false,
    toggleActions: 'play none none reverse'
  });

  // Hover animation
  jQuery(navbarBackground).parent().on('mouseenter', () => {
    if (jQuery(window).scrollTop() <= 0) {
      setNavbarBackgroundOpacity(navbarBackground, 1);
    }
  });

  jQuery(navbarBackground).parent().on('mouseleave', () => {
    var delayInMs = 0;
    var megaRow = navbarSection.find('.mad-navbar__row--mega');
    var timeoutId;
  
    if (jQuery(window).scrollTop() <= 0) {
      if (megaRow && megaRow.height() > 0) {
        delayInMs = 300;
      }
  
      timeoutId = setTimeout(() => {
        if (!jQuery(navbarBackground).parent().is(':hover')) {
          setNavbarBackgroundOpacity(navbarBackground, 0);
        }
      }, delayInMs);

      jQuery(navbarBackground).parent().on('mouseenter', () => {
        clearTimeout(timeoutId);
      });
    }
  });

  // Update background opacity onscroll
  jQuery(window).on('scroll', initBackgroundOpacity);
}

function setNavbarBackgroundOpacity(navbarBackground, opacity) {
  gsap.to(navbarBackground, {
    opacity: opacity,
    duration: 0.3
  });
}

module.exports = customizeNavbarSection;
